module.exports = "<div class=map></div>";


//////////////////
// WEBPACK FOOTER
// ../~/@printos/gazelle/src/components/google-maps/google-map.jade
// module id = 238
// module chunks = 0